import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";
import { forwardRef, useContext } from "react";

import { AlertContext } from "../context";

import styles from "./title.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Title = forwardRef<HTMLDivElement, Props>(
    ({ children, className, ...props }, ref) => {
        const { severity } = useContext(AlertContext);

        return (
            <div
                ref={ref}
                className={clsx(styles.title, className)}
                {...props}
                data-severity={severity}
            >
                {children}
            </div>
        );
    },
);
Title.displayName = "Title";

export { Title };
export type { Props as TitleProps };
